import { defineComponent, reactive } from 'vue';
export default defineComponent({
  name: 'NavHeader',
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  emits: ['change'],
  setup: function (props, _a) {
    var emit = _a.emit;
    var reactiveList = reactive(props.list);
    reactiveList[0].active = true;
    var onClickItem = function (item) {
      reactiveList.forEach(function (i) {
        return i.active = i.code === item.code;
      });
      emit('change', item);
    };
    return {
      reactiveList: reactiveList,
      onClickItem: onClickItem
    };
  }
});